module.exports = __webpack_public_path__ + "0f6aa89d72ce6d05a3927e51a9495224.ttf";